import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { AdminFormPage } from "@components/CatalogIndex";
import ScopeStackSpinner from "@components/ScopeStackSpinner/ScopeStackSpinner";
import { ClientForm } from "../ClientForm/ClientForm";
import { useClientMutations, useClientFormData } from "../api";
import { emptyClientForm } from "../types";
import type { ClientFormValues } from "../types";

const FORM_ID = "client-form";

export const New = (): JSX.Element => {
  const navigate = useNavigate();
  const { create } = useClientMutations();
  const { rateTables, projectVariables, isLoading } = useClientFormData();
  const [submitting, setSubmitting] = useState(false);

  if (isLoading) return <ScopeStackSpinner />;

  const handleSubmit = async (values: ClientFormValues) => {
    setSubmitting(true);
    try {
      const result: any = await create(values, projectVariables);
      const newId = result?.data?.id;
      navigate(newId ? `../${newId}/edit` : "..", {
        relative: "path",
        state: {
          toast: { variant: "success", text: `'${values.name}' saved` },
        },
      });
    } catch (err) {
      console.error("Failed to create client", err);
      setSubmitting(false);
    }
  };

  return (
    <AdminFormPage
      title="Add a Client"
      formId={FORM_ID}
      onCancel={() => navigate("..")}
      isSubmitting={submitting}
    >
      <ClientForm
        id={FORM_ID}
        initialValues={emptyClientForm}
        rateTables={rateTables}
        projectVariables={projectVariables}
        isSubmitting={submitting}
        onSubmit={handleSubmit}
      />
    </AdminFormPage>
  );
};

export default New;
